import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/add.png'


const _withScopeId = n => (_pushScopeId("data-v-aea5b40e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "top-label",
  style: {"text-align":"center"}
}
const _hoisted_2 = {
  class: "bottom-label",
  style: {"text-align":"center"}
}
const _hoisted_3 = {
  class: "top-label",
  style: {"text-align":"center","word-break":"normal"}
}
const _hoisted_4 = {
  class: "bottom-label",
  style: {"text-align":"center"}
}
const _hoisted_5 = {
  class: "top-label",
  style: {"text-align":"center","word-break":"normal"}
}
const _hoisted_6 = {
  class: "bottom-label",
  style: {"text-align":"center"}
}
const _hoisted_7 = {
  class: "top-label",
  style: {"text-align":"center","word-break":"normal"}
}
const _hoisted_8 = {
  class: "bottom-label",
  style: {"text-align":"center"}
}
const _hoisted_9 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_10 = { style: {"display":"flex","width":"125px","justify-content":"space-between","align-items":"center","text-align":"center"} }
const _hoisted_11 = {
  class: "top-label",
  style: {"text-align":"center","word-break":"normal"}
}
const _hoisted_12 = {
  class: "bottom-label",
  style: {"text-align":"center"}
}
const _hoisted_13 = { style: {"display":"flex","justify-content":"center","align-items":"center"} }
const _hoisted_14 = {
  key: 0,
  style: {"width":"20px","cursor":"pointer"},
  src: _imports_0,
  alt: "add-logo"
}
const _hoisted_15 = {
  key: 1,
  class: "table-button",
  style: {"cursor":"pointer","border":"1.5px solid #70ad47","padding":"2px 20px"}
}
const _hoisted_16 = {
  key: 2,
  class: "table-button",
  style: {"cursor":"pointer","border":"1.5px solid #ed7d31","padding":"2px 20px"}
}

import { ref } from "vue";
import type { Header, Item, SortType } from "vue3-easy-data-table";
import { useStore } from "vuex";

const sortType: SortType = "desc";

export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionTable',
  setup(__props) {

const generateRandomNumber = () => {
  const min = 10000000; // Smallest 8-digit number (10^7)
  const max = 99999999; // Largest 8-digit number (10^8 - 1)
  return Math.floor(Math.random() * (max - min + 1) + min);

}
const store = useStore();

function showTransaction(item: any) {
  store.commit("SET_TRANSACTION", item);
  store.commit("SET_SHOW_TRANSACTION_DIALOG", true);
}

// function getActionImage(action: string): string {
//   switch (action) {
//     case "Denied":
//       return require("@/assets/images/denied.png");
//     case "Allowed":
//       return require("@/assets/images/allowed.png");
//     case "ADD":
//       return require("@/assets/add.png");
//     default:
//       return "";
//   }
// }




function classColor(className: string) {
  switch (className) {
    case "Scam":
      return "#ed7d31";
    case "Valid":
      return "#70ad47";
    case "Attention":
      return "#FFFF00";
    case "In Progress":
      return "blue";
    case "Not Started":
      return "white";
    default:
      return "#000000";
  }
}

const itemsSelected: Item[] = ref([]);

const headers: Header[] = [
  { text: "Timestamp", value: "timestamp" },
  { text: "Customer", value: "customer" },
  { text: "Transaction", value: "transaction" },
  { text: "Entity", value: "entity" },
  { text: "Analysis", value: "analysis" },
  { text: "Team Member", value: "teamMember" },
  { text: "Action", value: "action" },
];

const date = new Date()

const monthNames = [
  "January", "February", "March", "April", "May", "June", "July",
  "August", "September", "October", "November", "December"
];

const month = monthNames[date.getMonth()];
const day = date.getDate();
const year = date.getFullYear();

const formattedDate = `${month} ${day}, ${year}`;

const customers: Item[] = [

  {
    "customer": { "fullname": "Louis Francois", "id": "#" + generateRandomNumber() },
    "transaction": { "amount": "$7,521.28", "type": "Check" },
    "entity": { "name": "Money Makers", "number": "***9241" },
    "timestamp": { "date": formattedDate, "time": "8:22 pm PST" },
    "analysis": { "class": "Not Started", "probability": "" },
    "teamMember": "Karla Jones",
    "action": "ADD"
  },
  {
    "customer": { "fullname": "Dong Lee", "id": "#" + generateRandomNumber() },
    "transaction": { "amount": "$20,000,00", "type": "Wire" },
    "entity": { "name": "Clear InvestCo", "number": "***7321" },
    "timestamp": { "date": formattedDate, "time": "8:52 pm PST" },
    "analysis": { "class": "In Progress", "probability": "" },
    "teamMember": "Amanda Smith",
    "action": "ADD"
  },

  {
    "customer": { "fullname": "Julio Garcia", "id": "#" + generateRandomNumber() },
    "transaction": { "amount": "$567.25", "type": "RTP" },
    "entity": { "name": "ACME Travel", "number": "***4342" },
    "timestamp": { "date": formattedDate, "time": "5:33 pm PST" },
    "analysis": { "class": "Attention", "probability": "" },
    "teamMember": "Karla Jones",
    "action": "ADD"
  },
  {
    "customer": { "fullname": "Jane Zimmer", "id": "#" + generateRandomNumber() },
    "transaction": { "amount": "$12,000.00", "type": "Zelle" },
    "entity": { "name": "Dave Long", "number": "***9822" },
    "timestamp": { "date": formattedDate, "time": "3:19 pm PST" },
    "analysis": { "class": "Scam", "probability": "95%" },
    "teamMember": "Joseph Dominguez",
    "action": "ADD"
  },
  {
    "customer": { "fullname": "Olena Artemenko", "id": "#" + generateRandomNumber() },

    "transaction": { "amount": "$5,315.47", "type": "ACH Debit Pull" },
    "entity": { "name": "Home Depot Card", "number": "***0293" },
    "timestamp": { "date": formattedDate, "time": "2:24 pm PST" },
    "analysis": { "class": "Valid", "probability": "90%" },
    "teamMember": "Amanda Smith",
    "action": "Allowed"
  },
  {
    "customer": { "fullname": "John Daggar", "id": "#" + generateRandomNumber() },

    "transaction": { "amount": "$15,000.00", "type": "ACH Debit Push" },
    "entity": { "name": "EverFX", "number": "***8623" },
    "timestamp": { "date": formattedDate, "time": "12:38 pm PST" },
    "analysis": { "class": "Scam", "probability": "100%" },
    "teamMember": "Karla Jones",
    "action": "Denied"
  },
  {
    "customer": { "fullname": "Sana Khan", "id": "#" + generateRandomNumber() },
    "transaction": { "amount": "$3,385.44", "type": "Wire" },
    "entity": { "name": "The Coffee Corner", "number": "***1236" },
    "timestamp": { "date": formattedDate, "time": "11:41 am PST" },
    "analysis": { "class": "Valid", "probability": "89%" },
    "teamMember": "Joseph Dominguez",
    "action": "Allowed"
  },
  {
    "customer": { "fullname": "Emeka Okafor", "id": "#" + generateRandomNumber() },
    "transaction": { "amount": "$9,900.00", "type": "Wire" },
    "entity": { "name": "Fusion Architects", "number": "***9871" },
    "timestamp": { "date": formattedDate, "time": "11:39 am PST" },
    "analysis": { "class": "Scam", "probability": "71%" },
    "teamMember": "Karla Jones",
    "action": "Denied"
  }

];

return (_ctx: any,_cache: any) => {
  const _component_EasyDataTable = _resolveComponent("EasyDataTable")!

  return (_openBlock(), _createBlock(_component_EasyDataTable, {
    "items-selected": itemsSelected.value,
    "onUpdate:itemsSelected": _cache[0] || (_cache[0] = ($event: any) => ((itemsSelected).value = $event)),
    headers: headers,
    "checkbox-column-width": 36,
    "fixed-checkbox": "",
    onClickRow: showTransaction,
    items: customers,
    "sort-type": sortType
  }, {
    "item-timestamp": _withCtx(({ timestamp }) => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(timestamp.date), 1),
      _createElementVNode("div", _hoisted_2, _toDisplayString(timestamp.time), 1)
    ]),
    "item-customer": _withCtx(({ customer }) => [
      _createElementVNode("div", _hoisted_3, _toDisplayString(customer.fullname), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(customer.id), 1)
    ]),
    "item-transaction": _withCtx(({ transaction }) => [
      _createElementVNode("div", _hoisted_5, _toDisplayString(transaction.amount), 1),
      _createElementVNode("div", _hoisted_6, _toDisplayString(transaction.type), 1)
    ]),
    "item-entity": _withCtx(({ entity }) => [
      _createElementVNode("div", _hoisted_7, _toDisplayString(entity.name), 1),
      _createElementVNode("div", _hoisted_8, _toDisplayString(entity.number), 1)
    ]),
    "item-analysis": _withCtx(({ analysis }) => [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            style: _normalizeStyle({


            marginRight: '5px', minWidth: '15px', height: '15px', borderRadius: '100%', background:
              `${classColor(analysis.class)}`, border: '1px solid gray'
          })
          }, null, 4),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(analysis.class), 1),
            _createElementVNode("div", _hoisted_12, _toDisplayString(analysis.probability), 1)
          ])
        ])
      ])
    ]),
    "item-action": _withCtx(({ action }) => [
      _createElementVNode("div", _hoisted_13, [
        (action === 'ADD')
          ? (_openBlock(), _createElementBlock("img", _hoisted_14))
          : (action === 'Allowed')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Allowed"))
            : (action === 'Denied')
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Denied"))
              : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["items-selected"]))
}
}

})